import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbStatic = [{
	name: "Rolling TORs",
	url: '/managers/rolling_tors',
	icon: 'dashboard'
}];

export default class ReadOnlyTORs extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history, roles} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.TimeOff
							history={history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={roles.includes(UserRoles.Admin)}
							read_only={true}
							main_role={10} //this is to allow seeing all data/filtering
						/>
					</div>
				</div>
			</div>
		)
	}
}
